<script setup lang="ts">
import { defineProps } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'

import 'swiper/css'
import BaseButton from '@/components/Buttons/BaseButton.vue'
const props = defineProps(['catalog'])

</script>
<template>
  <swiper
    :slides-per-view="'auto'"
    :space-between="20"
    class="slider"
    :loop="true"
    :centered-slides="true"
    :centeredSlidesBounds="true"
  >
    <swiper-slide :key="`slide_${index}`" v-for="(slide, index) in props.catalog?.results" class="slide">
      <router-link :to="{name: 'project', params: {id: slide?.url}}" class="full-width">
        <img class="slide__background" :src="slide?.thumbnail" :alt="slide?.description?.title" />
        <div class="slide__wrapper">
          <div class="ribbons">
            <BaseButton v-if="slide?.description?.premiere" class="uppercase" bg="gradient">премьера</BaseButton>
            <BaseButton v-if="slide?.description?.soon" class="uppercase" bg="gradient">скоро</BaseButton>
            <BaseButton v-if="slide?.description?.new_episode" class="uppercase" bg="gradient">новая серия</BaseButton>
          </div>
          <div class="slide__info">
            <h3 class="slide__info-title">{{slide?.description?.title}}</h3>
            <h5 class="slide__info-description" v-html="slide?.description?.short_description"/>
            <h6 class="slide__info-category uppercase">{{slide?.description?.playlist_spec}}</h6>
          </div>
        </div>
      </router-link>
    </swiper-slide>
  </swiper>
</template>

<style scoped lang="less">
.slider {
  padding: 20px 10px;
  .slide {
    width: 40%;
    display: inline-flex;
    overflow: hidden;
    border-radius: 20px;
    position: relative;
    &__background {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    &__wrapper {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 15px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 53.13%, rgba(0, 0, 0, 0.7) 100%);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .ribbons {
        .btn {
          &:nth-child(2), &:nth-child(3) {
            display: none;
          }
        }
      }
    }
    &__info {
      &-description {
        font-size: 0.8em;
      }
    }
  }
}
@media (min-width:767px) and (max-width:1024px) {
  .slider {
    .slide {
      width: 50%;
      &__info {
        &-description {
          font-size: 1em;
        }
      }
    }
  }
}
@media (max-width:767px){
  .slider {
    .slide {
      width: 75%;
      &__info {
        &-description {
          font-size: 0.8em;
        }
      }
    }
  }
}
@media all and (orientation:landscape) and (min-height: 968px) {
  .slider {
    .slide {
      width: 50%;
    }
  }
}
</style>
